import { Alert } from 'react-bootstrap';

interface SuccessAlertProps {
  message: string;
  onDismiss?: () => void;
}

export default function SuccessAlert({ message, onDismiss }: SuccessAlertProps) {
  return (
    <Alert variant="success" dismissible={!!onDismiss} onClose={onDismiss}>
      {message}
    </Alert>
  );
}

